import { Relays } from 'constants/Relays'
import { GetRelay, SetRelay, useRelay } from 'phoenix/hooks/UseRelay'

export const useRouteLocation = () => useRelay<any>(Relays.RouteLocation)
export const SetRouteLocation = (location: any) => SetRelay(Relays.RouteLocation, location)
export const GetRouteLocation = () => GetRelay(Relays.RouteLocation)